/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 15:46:45
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-11 11:59:05
 * @name: 通讯录模块服务
 * @Description: 通讯录模块服务
 * @FilePath: \project\src\module\department\department.service.js
 * @Author: desktop
 */
import departmentController from "./department.controller";
const departmentService = class {
  constructor() {
    this.departmentController = new departmentController();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取用户信息
   */
  getUserInfo(req) {
    return new Promise((resolve, reject) => {
      this.departmentController.userDetail(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取人员列表
   */
  getList(req) {
    return new Promise((resolve, reject) => {
      this.departmentController.getList(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
}
export default departmentService;